
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-tree-view/rich-tree-view/selection",
      function () {
        return require("private-next-pages/x/react-tree-view/rich-tree-view/selection.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-tree-view/rich-tree-view/selection"])
      });
    }
  